var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#336",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.618 13.456l-2.534-2.535a1.006 1.006 0 0 0-1.407-.003l.306-.304a.988.988 0 0 0 .003 1.406l2.925 2.926c.39.39 1.036.397 1.428.028l6.681-6.295a.967.967 0 0 0 .01-1.39l.328.328a1.038 1.038 0 0 0-1.437-.035l-6.303 5.874z"
}))));
export default __webpack_public_path__ + "teg/media/statusbarChecked.1.e4b81bc2.svg";
export { SvgComponent as ReactComponent };